import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../../modules/customer-zone/services/customer-service.service';
import { ModifiedSepadetails, NewSepaMandate } from '../../models/SepaMandateViewModel';
import { RouteNames } from '../../routing/app-routing.constants';
import { HelperService } from '../../services/helper.service';
import { SilToastrService, ToastrType } from '../../services/sil-toastr.service';

@Component({
  selector: 'app-esign-handler',
  template: ''
})
export class EsignHandlerComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly customerService: CustomerService, 
    private readonly helperService: HelperService,
    private readonly toastr: SilToastrService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = params.id as string;
      const status = params.status as string;
      const isNewSepaFlow = sessionStorage.getItem('newsepaesignflow');
      const isModifySepaFlow = sessionStorage.getItem('modifySepaEsignFlow');
      if (isNewSepaFlow === 'true' || isModifySepaFlow === 'true') {
        sessionStorage.removeItem('newsepaesignflow');
        sessionStorage.removeItem('modifySepaEsignFlow');
        this.nextActionForSepa(id, status, isNewSepaFlow, isModifySepaFlow);
      }
      else {
        void this.router.navigate([`${RouteNames.eSign}/${id}/${status}`]);
      }
    });

  }

  private nextActionForSepa(id: string, status: string, isNewSepaFlow: string, isModifySepaFlow: string): void{
    if (status === 'SIGNED'){
      this.customerService.updateMandate(id, true, isModifySepaFlow === 'true').subscribe(res => {
        if(res?.Status){
          this.helperService.clearSession('newsepaData');
          this.helperService.clearSession('modifiedSepaSessionData');
          void this.router.navigate([`${RouteNames.customerZone}/${RouteNames.myFund}/${RouteNames.myplan}/${res.PlanId}`]);
          if(isNewSepaFlow) setTimeout(() => {this.toastr.showToast('CreateSepaMandate.Sepa-esign-success', ToastrType.success);}, 2000);
          if(isModifySepaFlow) setTimeout(() => {this.toastr.showToast('EditPayment.IbanModificationSuccessMessage', ToastrType.success);}, 2000);
        }
      });
    }else{
      if (isNewSepaFlow){
        const sepaDetails = JSON.parse(this.helperService.getSessionValue('newsepaData')) as NewSepaMandate;
        this.customerService.setCurrentSepaDetails = {
          PersonID: sepaDetails.PersonID,
          ContractExtRef: sepaDetails.ContractExtRef,
          PlanID: sepaDetails.PlanID,
          Amount: sepaDetails.Amount,
          IBAN: sepaDetails.IBAN,
          esignId: this.helperService.getSessionValue('signatureRequestId')
        }
        void this.router.navigate([`/${RouteNames.customerZone}/${RouteNames.createsepamandate}`]);
        this.toastr.showToast('CreateSepaMandate.Sepa-esign-error', ToastrType.error);
      } 
      if (isModifySepaFlow){
        const sepaDetails = JSON.parse(this.helperService.getSessionValue('modifiedSepaSessionData')) as ModifiedSepadetails;
        void this.router.navigate([`/${RouteNames.customerZone}/${RouteNames.editPayment}`],
          {
            state: {
              contractData: {
                currentNextDueDate: sepaDetails.CurrentNextDueDate,
                currentAmount: sepaDetails.Amount,
                planID: sepaDetails.PlanID,
                contractRef: sepaDetails.ContractExtRef,
                iban: sepaDetails.IBAN,
                esignId: sepaDetails.esignId,
                isIbanModificationRetry: true,
                nextdueDateChangeBankAccount: sepaDetails.NextdueDateChangeBankAccount,
                HasMoreThenOneActiveRecurrentPayment : sepaDetails.HasMoreThenOneActiveRecurrentPayment,
                branchId : sepaDetails.branchId
              }
            }
          });
      }
    }
  }

}
